export function clearBookingData() {
    const bookingKeys = [
      'bookingName',
      'bookingPhone',
      'bookingEmail',
      'bookingGuests',
      'bookingDate',
      'reservationId',
      'date',
      'duration',
      'selectedTable',
      'selectedTableName',
      'cart'
    ];
    bookingKeys.forEach(key => localStorage.removeItem(key));
    console.log('Booking data cleared');
  }
  
  export function clearCheckoutData() {
    const checkoutKeys = [
      'redirectToCheckout',
      'redirectToBookingDuration',
      'checkoutCart',
      'checkoutDeliveryAddress',
      'checkoutSpecialRequest',
      'checkoutPaymentMethod',
      'cart'
    ];
    checkoutKeys.forEach(key => localStorage.removeItem(key));
    console.log('Checkout data cleared');
  }
  